export default class {
  constructor (model) {
    this.id = model.id
    this.question = model.question
    this.answer = model.answer
  }
}
